import { loginRequest, msalInstance } from "../config/api.config";
import HeaderFarms from "../utils/header_farms";
import API from "../services";
import { useUserStore } from "../stores/user/userStore";

// Offline token storage keys
const OFFLINE_TOKEN_KEY = "offline_access_token";
const OFFLINE_TOKEN_EXPIRY_KEY = "offline_token_expiry";

// Flag agar handleRedirectPromise hanya dipanggil sekali
let redirectHandled = false;
let redirectPromise = null;

export const requestToken = async (allowRedirect = true, skipSessionSync = false) => {
  const storedToken = getOfflineToken();

  // 📴 1️⃣ Offline mode: pakai token lokal kalau ada
  if (!navigator.onLine) {
    if (storedToken) {
      console.log("Offline: using stored token");
      return storedToken;
    }
    console.warn("Offline and no stored token");
    return null;
  }

  // 🔁 2️⃣ Handle redirect hanya sekali
  if (!redirectHandled) {
    if (!redirectPromise) {
      redirectPromise = msalInstance
        .handleRedirectPromise()
        .then((redirectResponse) => {
          redirectHandled = true;
          if (redirectResponse && redirectResponse.account) {
            msalInstance.setActiveAccount(redirectResponse.account);
            console.log("✅ Account set from redirect:", redirectResponse.account.username);
          }
          return redirectResponse;
        })
        .catch((err) => {
          redirectHandled = true;
          console.error("❌ Redirect error:", err);
          return null;
        });
    }
    await redirectPromise;
  }

  // 🔁 3️⃣ Ambil akun aktif
  let account = msalInstance.getActiveAccount();
  const accounts = msalInstance.getAllAccounts();

  if (!account && accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
    account = accounts[0];
    console.log("✅ Active account set from existing accounts:", account.username);
  }

  if (!account) {
    if (allowRedirect) {
      console.warn("⚠️ No account found, redirecting to login");
      return msalInstance.loginRedirect(loginRequest);
    }
    return null;
  }

  // 🔁 4️⃣ Ambil token
  try {
    const responseToken = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
    });

    console.log("✅ Token acquired successfully for:", account.username);

    // Simpan token untuk offline use
    storeOfflineToken(responseToken.accessToken, responseToken.expiresOn);

    // 🔁 5️⃣ Panggil API dan simpan ke localStorage (skip kalau caller tidak butuh)
    if (!skipSessionSync) {
      try {

        const res = await API.getUserCredential(HeaderFarms(responseToken.accessToken), {
          access_token: responseToken.accessToken,
        });

        const results = await API.getSessionSignin(HeaderFarms(responseToken.accessToken));

        localStorage.setItem("session_signin", JSON.stringify(res));
        localStorage.setItem("session_farms", JSON.stringify(results));

        useUserStore.getState().setUserData(results);

        console.log("✅ Session data stored in localStorage and Zustand store");
      } catch (apiError) {
        console.error("❌ Failed to fetch or store session data:", apiError);
      }
    }

    return responseToken.accessToken;

  } catch (error) {

    console.warn("⚠️ acquireTokenSilent failed:", error.errorCode || error.message);

    // Jika butuh interaksi, redirect login ulang
    if (error.errorCode === "interaction_required" || error.errorCode === "consent_required") {
      if (allowRedirect) {
        console.log("🔄 Interaction required, attempting redirect...");
        try {
          await msalInstance.acquireTokenRedirect({
            ...loginRequest,
            account,
          });
        } catch (redirectError) {
          console.error("❌ Redirect failed:", redirectError);
        }
      }
      return null;
    }

    // Gunakan token offline kalau ada
    if (storedToken) {
      console.log("ℹ️ Using stored offline token");
      return storedToken;
    }

    // Kalau benar-benar tidak ada token sama sekali
    if (allowRedirect) {
      console.warn("⚠️ No token available, redirecting to /home anyway...");
      window.location.href = "/";
    }

    return null
  }
};

// ======================================
// 🧩 Helper Functions
// ======================================

const storeOfflineToken = (token, expiresOn) => {
  try {
    localStorage.setItem(OFFLINE_TOKEN_KEY, token);
    if (expiresOn) {
      localStorage.setItem(OFFLINE_TOKEN_EXPIRY_KEY, expiresOn.getTime().toString());
    }
  } catch (error) {
    console.error("Failed to store offline token:", error);
  }
};

const getOfflineToken = () => {
  try {
    const token = localStorage.getItem(OFFLINE_TOKEN_KEY);
    if (!token) return null;

    const expiry = localStorage.getItem(OFFLINE_TOKEN_EXPIRY_KEY);
    if (!expiry) return token;

    const daysDiff = (Date.now() - parseInt(expiry)) / (1000 * 60 * 60 * 24);

    // Token valid 30 hari untuk offline
    if (daysDiff > 30) {
      console.warn("Token expired >30 days");
      return null;
    }

    return token;
  } catch (error) {
    return null;
  }
};
